import script from "./Cookie.vue?vue&type=script&setup=true&lang=js"
export * from "./Cookie.vue?vue&type=script&setup=true&lang=js"

import "./Cookie.vue?vue&type=style&index=0&id=01150e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01150e40"]])

export default __exports__